import ProductInfo from "./ProductInfo";
import productImage from "../../../assets/images/Products/DirectoryModern1.png";

function EmployeeDirectory() {
  return (
    <>
      <ProductInfo
        title="Employee Directory And Org Chart"
        primaryDescription="Employee directory And Org Chart is a SharePoint Framework(SPFx)
                solution for SharePoint and Microsoft Teams which has
                webparts to search for the users and communicate with them"
        secondaryDescription="The webparts have modern responsive design so that it fits in
                  any part of the page with any resolution. These webparts
                  inherits the theme of SharePoint and seamlessly blends in with
                  other contents of the page."
        features={[
          "Support for SharePoint Webpart, Full-Page webpart components",
          "Support for Teams Tab",
          "Design which follows the modern UI of SharePoint",
          "Advanced search feature on employee directory",
          "All webparts are available as Team channel tab",
          "Expandable and collapsible organization chart in all directions",
          "Directory and Organization chart are available as web parts which can be used in modern and classic SharePoint pages",
          "Employee directory web part has department property so that it can be used to display department specific directory",
          "Organization chart web part has root user email property so that it can be used to show a subset of the entire organization hierarchy",
        ]}
        image={productImage}
        appsourceLink="https://appsource.microsoft.com/en-us/product/office/WA200007242?tab=Overview"
        youTubeLink="https://www.youtube.com/embed/VnUGS6JPpO0"
        pricings={[
          {
            userLimit: "Unlimited",
            price: "$299.99 USD", //"$599.99 USD",
            priceText: "/Year",
            // offerText: "One-Time Payment for a Lifetime License",
            secondaryText: "Billed Annually",
            paymentLink: "https://buy.stripe.com/28EcN7cGUe1Z55sfj99Ve0r", //"https://buy.stripe.com/7sI5mbezn5vM2is8wR",
          },
        ]}
      />
    </>
  );
}

export default EmployeeDirectory;
